module.exports = __webpack_public_path__ + "media/images/seller-guide-nikki-thumb-76da29e17921df93961d580585344e4f.jpg";